import * as React from 'react';
import { IIconProps } from './IIconProps';

const UserRounded: React.FunctionComponent<IIconProps> = ({ size = 'sm', color = "currentColor" }) => {
  return <svg width={16} height={17} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x={1} y="1.5" width={14} height={14} rx={7} stroke={color} strokeWidth="1.5" />
    <rect x={6} y="5.5" width={4} height={4} rx={2} stroke={color} strokeWidth="1.5" />
    <path d="M11 14.5V12.8333C11 12.4797 10.842 12.1406 10.5607 11.8905C10.2794 11.6405 9.89782 11.5 9.5 11.5H6.5C6.10218 11.5 5.72064 11.6405 5.43934 11.8905C5.15804 12.1406 5 12.4797 5 12.8333V14.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
};

export default UserRounded;
